<input (focus)="drawTippy()" [formControl]="formControl" [placeholder]="placeholder || ''" tabindex="0" type="text">
<i class="material-icons" (click)="drawTippy()">{{ open ? 'expand_less' : 'expand_more' }}</i>

<ng-template #optionList let-options>
  <div class="options">
    @for (option of options; track option; let idx = $index) {
      <div class="option-container"
        [class.focused]="idx === focusedOption" (click)="selectValue(option)">
        @if (displayTemplate) {
          <ng-container [ngTemplateOutlet]="displayTemplate"
          [ngTemplateOutletContext]="{option: option, idx: idx}"></ng-container>
        } @else {
          <span class="defaultTemplate" [innerHTML]="displayWith(opt) | highlight:formControl.value">
          </span>
        }
        <ng-template #defaultTemplate let-opt="option">
          <span class="defaultTemplate" [innerHTML]="displayWith(opt) | highlight:formControl.value">
          </span>
        </ng-template>
      </div>
    }
    @if (!selectOnly && formControl.value) {
      <span class="use" (click)="selectTyped()">
        Use "{{ formControl.value }}"
      </span>
    }
  </div>
</ng-template>
